"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _filterDrawer = _interopRequireDefault(require("@/components/filterDrawer"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'BindEquip',
  components: {
    Pagination: _Pagination.default,
    drawer: _filterDrawer.default
  },
  data: function data() {
    return {
      nowTime: Date.parse(new Date()) / 1000,
      form: {},
      tableMaxH: '250',
      list: [],
      listLoading: true,
      listQuery: {
        search_goods_type: 0,
        search_user_type: 0,
        page_num: 1
      }
    };
  },
  computed: {
    deviceNameObj: function deviceNameObj() {
      return this.$store.state.user.deviceNameObj;
    }
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    /**
     * 搜索查询
     */
    toQuery: function toQuery() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (type == 1) {
        this.form = {};
        this.listQuery.start = 1;
      } else {
        this.listQuery.start = 1;
      }
      this.getList();
    },
    getList: function getList() {
      var _this = this;
      var listQuery = Object.assign({}, this.listQuery, this.form, {
        start: this.listQuery.start - 1
      });
      if (this.sort_id_key && window.sort_id_key) listQuery.sort_id_key = window.sort_id_key;
      this.$get('agentapi/statistics/business_device_data', listQuery).then(function (res) {
        _this.listLoading = false;
        _this.list = res.list;
        _this.listQuery.page_num = res.page_num;
        if (listQuery.start == 0) _this.tableMaxH = window.innerHeight - _this.$refs.equip_table.$el.offsetTop - 85;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    sortChange: function sortChange(column) {
      if (column.order) {
        this.listQuery.sort_field_key = column.prop;
        this.listQuery.sort_order = column.order == 'ascending' ? 0 : 1;
      } else {
        delete this.listQuery.stype;
        delete this.listQuery.sort_order;
      }
      this.toQuery();
    }
  }
};